import apiV2 from '../api/v2';
import { toDmError } from './dmErrors';
import { resolveSignedUrl } from './signedUrl';

export interface RejectedScanPhoto {
    key: string;
    label: string;
    previewUrl: string | null;
    originalUrl: string | null;
}

export interface RejectedScanView {
    view: string;
    label: string;
    photos: RejectedScanPhoto[];
}

export interface RejectedScan {
    scanId: number;
    creationDate: string;
    uploadDate: string | null;
    type: string | null;
    review: 'refused' | 'rejected';
    alignerIndex: number | null;
    reasons: string[];
    views: RejectedScanView[];
    photosUnavailable: boolean;
}

export interface RejectedScansResponse {
    scans: RejectedScan[];
    total: number;
}

const HTTP_FORBIDDEN = 403;
export const STAFF_ONLY_MESSAGE = 'Only ODO staff can view rejected scans';

function resolveView(view: RejectedScanView): RejectedScanView {
    return {
        ...view,
        photos: view.photos.map((photo) => ({
            ...photo,
            previewUrl: resolveSignedUrl(photo.previewUrl),
            originalUrl: resolveSignedUrl(photo.originalUrl)
        }))
    };
}

export async function fetchRejectedScans(patientId: string): Promise<RejectedScansResponse> {
    try {
        const response = await apiV2.get<{ success: boolean; data: RejectedScansResponse }>(
            `/patients/${patientId}/monitoring/scans/rejected`,
            // Resolving the 403 keeps apiV2's interceptor from redirecting the page to /forbidden.
            {
                validateStatus: (status) =>
                    (status >= 200 && status < 300) || status === HTTP_FORBIDDEN
            }
        );
        if (response.status === HTTP_FORBIDDEN) throw new Error(STAFF_ONLY_MESSAGE);
        const { scans, total } = response.data.data;
        return {
            scans: scans.map((scan) => ({ ...scan, views: scan.views.map(resolveView) })),
            total
        };
    } catch (error) {
        throw toDmError(error);
    }
}
